module.exports = __webpack_public_path__ + "img/25.871a4f73.jpg";